// removed by extract-text-webpack-plugin
module.exports = {"root":"stackCarousel__root--1zqfR","wrapper":"stackCarousel__wrapper--3KL_B","card":"stackCarousel__card--vfWyC","cardActive":"stackCarousel__cardActive--1F8YO stackCarousel__card--vfWyC","cardInactive":"stackCarousel__cardInactive--34XHx stackCarousel__card--vfWyC","enter":"stackCarousel__enter--2Hy6d","overlay":"stackCarousel__overlay--3-Nyg","sliderButton":"stackCarousel__sliderButton--1c-Rv","prevSlideButton":"stackCarousel__prevSlideButton--3QkdZ stackCarousel__sliderButton--1c-Rv","nextSlideButton":"stackCarousel__nextSlideButton--25eZ0 stackCarousel__sliderButton--1c-Rv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/StackCarousel/stackCarousel.css
// module id = m2sg
// module chunks = 0